<template>
  <div class="alarm-page">
    <TotalAlarm class="total-alarm-card"></TotalAlarm>
    <TableAlarm class="table-alarm-card"></TableAlarm>
    <ProjectAlarm class="project-alarm-card"></ProjectAlarm>
    <CategoryAlarm class="category-alarm-card"></CategoryAlarm>
  </div>
</template>

<script setup lang="ts">
import TotalAlarm from './components/TotalAlarm.vue'
import TableAlarm from './components/TableAlarm.vue'
import ProjectAlarm from './components/ProjectAlarm.vue'
import CategoryAlarm from './components/CategoryAlarm.vue'
</script>

<style scoped lang="scss">
.alarm-page {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 1fr 1fr;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;

  .total-alarm-card {
    grid-row: 1 / 3;
    grid-column: 1;
  }

  .table-alarm-card {
    grid-row: 1 / 3;
    grid-column: 2;
  }

  .project-alarm-card {
    grid-row: 1;
    grid-column: 3;
  }

  .category-alarm-card {
    grid-row: 2;
    grid-column: 3;
  }
}

@media screen and (max-width: 1200px) {
  .alarm-page {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;

    .total-alarm-card {
      grid-row: 1;
      grid-column: 1;
      min-height: 400px;
    }

    .table-alarm-card {
      grid-row: 1 / 3;
      grid-column: 2;
      min-height: 600px;
    }

    .project-alarm-card {
      grid-row: 2;
      grid-column: 1;
      min-height: 300px;
    }

    .category-alarm-card {
      grid-row: 3;
      grid-column: 1 / 3;
      min-height: 300px;
    }
  }
}

@media screen and (max-width: 768px) {
  .alarm-page {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);

    .total-alarm-card,
    .table-alarm-card,
    .project-alarm-card,
    .category-alarm-card {
      grid-row: auto;
      grid-column: 1;
      min-height: 400px;
    }
  }
}
</style>
